import styled, { css } from 'styled-components';
import { fontSize, space, themeGet, width } from 'styled-system';
import { getPaletteColor } from '../utils';
var BaseCSS = css(["margin:", "px 0;color:", ";& > li{margin:", "px 0;}", ";", ";", ";"], themeGet('space.1'), getPaletteColor('base'), themeGet('space.1'), fontSize, space, width);
var Ordered = styled('ol').withConfig({
  displayName: "List__Ordered",
  componentId: "hex569-0"
})(["", ";& > li > *{margin-left:", "px;}"], BaseCSS, themeGet('space.2'));
var Unordered = styled('ul').withConfig({
  displayName: "List__Unordered",
  componentId: "hex569-1"
})(["", ";"], BaseCSS);
var List = Unordered;
List.ol = Ordered;
List.ol.displayName = 'OrderedList';
List.ul = Unordered;
List.ul.displayName = 'UnorderedList';
export default List;